import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class RoutesStatsService {
  constructor(private http: HttpClient) {}

  public all(params: any) {
    let projectId;

    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v5/projects/${projectId}/routes-stats`;

    return this.http.get(url, { params });
  }

  public get(params: any) {
    let projectId;
    let routeId;

    [params, projectId, routeId] = splayParams(params, "projectId", "routeId");
    const url = `/api/v5/projects/${projectId}/routes/${routeId}/stats`;

    return this.http.get(url, { params });
  }
}
